module.exports = __webpack_public_path__ + "assets/images/animations/laus-ribbon.png?ecc363c8";